import { LocalStorageService } from './local-storage.service';

export const isCompanyProtectedRoute = (
  skipCompanyProtectionRoutes: string[]
): boolean => {
  let isProtected = true;

  const storedRoute = LocalStorageService.getStoredRedirectRoute();

  if (storedRoute) {
    isProtected = !skipCompanyProtectionRoutes?.some((skipRoute) =>
      storedRoute.includes(skipRoute)
    );
  }

  return isProtected;
};
